import { useMediaQuery } from '@mui/material';

export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/** The one source for the `prefers-reduced-motion: reduce` preference (row sorting, drag overlays, row transitions). */
export function useReducedMotion(): boolean {
  return useMediaQuery(REDUCED_MOTION_QUERY);
}

/** `sx` that turns every transition and animation inside an element off - spread it on a panel root. */
export const NO_MOTION_SX = {
  '& *, & *::before, & *::after': { transitionDuration: '0s !important', animationDuration: '0s !important' }
} as const;
